export default "__VITE_ASSET__LzkyhQ5e__"